<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[1100px] mx-auto">

    <!-- Header -->
    <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-6">
      <div class="flex items-center gap-4 min-w-0">
        <button type="button" (click)="backToList()"
          class="h-10 w-10 flex-shrink-0 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:text-gray-900 hover:border-amber-300 transition-colors"
          matTooltip="Back to coupons" aria-label="Back to coupons">
          <mat-icon>arrow_back</mat-icon>
        </button>
        @if (coupon) {
          <span class="h-12 w-16 rounded-xl flex flex-col items-center justify-center flex-shrink-0 bg-gradient-to-br from-amber-300 to-amber-500 text-neutral-900 shadow-sm shadow-amber-200">
            <span class="text-base font-extrabold leading-none tabular-nums">{{ valueLabel(coupon) }}</span>
            <span class="text-[9px] font-bold uppercase tracking-[0.2em] opacity-70">off</span>
          </span>
        } @else {
          <span class="h-12 w-12 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center flex-shrink-0"><mat-icon>local_offer</mat-icon></span>
        }
        <div class="min-w-0">
          <div class="flex items-center gap-1.5 text-xs text-gray-400">
            <button type="button" class="hover:text-gray-700" (click)="backToList()">Discount Coupons</button>
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">chevron_right</mat-icon>
            <span>{{ isEdit ? 'Edit' : copyOf ? 'Copy' : 'New' }}</span>
          </div>
          <h1 class="text-2xl font-bold text-gray-900 tracking-tight truncate max-w-[70vw] lg:max-w-[520px]">
            @if (loading) { Loading… }
            @else if (isEdit) { <span class="font-mono">{{ coupon?.couponCode }}</span> }
            @else if (copyOf && coupon) { Copy of <span class="font-mono">{{ coupon.couponCode }}</span> }
            @else { New coupon }
          </h1>
          <p class="text-xs text-gray-500">{{ isEdit ? 'Changes apply to new orders straight away' : copyOf ? 'Give the copy its own code, then adjust anything else' : 'Fill in the basics, then set any limits or restrictions' }}</p>
        </div>
      </div>
      @if (isEdit && navTotal) {
        <app-record-nav noun="coupon" listName="Discount Coupons" [position]="position" [total]="navTotal"
          [prevName]="prev?.c?.couponCode ?? null" [nextName]="next?.c?.couponCode ?? null" [disabled]="loading" (prev)="goTo(prev)" (next)="goTo(next)"></app-record-nav>
      }
    </div>

    @if (loading) {
      <div class="rounded-2xl bg-white border border-gray-100 py-24 flex flex-col items-center justify-center text-sm text-gray-500">
        <mat-spinner diameter="40"></mat-spinner><span class="mt-3">Loading coupon&hellip;</span>
      </div>
    } @else if (notFound) {
      <div class="rounded-3xl border-2 border-dashed border-gray-200 bg-white py-16 text-center">
        <span class="mx-auto h-14 w-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon class="!text-[28px] !h-7 !w-7">search_off</mat-icon></span>
        <p class="mt-3 text-sm font-semibold text-gray-700">That coupon doesn't exist</p>
        <button type="button" class="mt-4 text-xs font-semibold text-amber-700 hover:underline" (click)="backToList(true)">Back to coupons</button>
      </div>
    } @else if (formData) {
      @if (isEdit && coupon) {
        <div class="mb-5 grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div class="rounded-2xl bg-white border border-gray-100 shadow-sm px-4 py-3"><div class="text-[10px] font-semibold uppercase tracking-wide text-gray-400">Used</div><div class="text-xl font-bold text-gray-900 tabular-nums">{{ coupon.used ?? 0 | number }}</div></div>
          <div class="rounded-2xl bg-white border border-gray-100 shadow-sm px-4 py-3"><div class="text-[10px] font-semibold uppercase tracking-wide text-gray-400">Last used</div><div class="text-sm font-bold text-gray-900 mt-1">{{ coupon.lastUsed ? (coupon.lastUsed | date:'d MMM y') : 'Never' }}</div></div>
          <div class="rounded-2xl bg-white border border-gray-100 shadow-sm px-4 py-3"><div class="text-[10px] font-semibold uppercase tracking-wide text-gray-400">Expires</div><div class="text-sm font-bold text-gray-900 mt-1">{{ coupon.expiryDate ? (coupon.expiryDate | date:'d MMM y') : 'No expiry' }}</div></div>
          <div class="rounded-2xl bg-white border border-gray-100 shadow-sm px-4 py-3"><div class="text-[10px] font-semibold uppercase tracking-wide text-gray-400">Status</div>
            <div class="text-sm font-bold mt-1" [ngClass]="coupon.status === 'expired' ? 'text-gray-500' : coupon.status === 'usedUp' ? 'text-rose-600' : coupon.status === 'expiring' ? 'text-amber-700' : 'text-emerald-700'">
              {{ coupon.status === 'expired' ? 'Expired' : coupon.status === 'usedUp' ? 'Used up' : coupon.status === 'expiring' ? 'Expiring soon' : 'Active' }}
            </div>
          </div>
        </div>
      }
      <app-add-edit-coupons [pageData]="formData" (done)="onDone($event)"></app-add-edit-coupons>
    }
  </div>
  </div>
</app-main-layout>
